import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          maxWidth: 360,
          boxShadow: 'var(--shadow-md)',
          background: 'var(--popover, #ffffff)',
          color: 'var(--text-primary, #000000)',
          border: '1px solid var(--border-default, #dfe3e7)',
        },
        classNames: {
          success: 'toast-success',
          error: 'toast-error',
          info: 'toast-info',
          warning: 'toast-warning',
        },
      }}
      offset={16}
    />
  );
}
